export default "/images/Money.svg?ea5ca9f2e3445bc0d4174d3d40d48a99";